import { Link } from "react-router-dom";
import { BuildingEntryType } from "../../Types/buildingTypes";
import { Button, Card } from "react-bootstrap";
import { formatAddress, googleAddress } from "../../Helpers/Property/propertyAddressFormatters";
import timeService from "../../services/time/timeService";

export default function BuildingEntry(props: {
    buildingInfo: BuildingEntryType,
    details?: boolean,
    disableLinks?: { [key: string]: number },
    extraButtons?: any[]
}) {
    const {
        buildingInfo,
        details = false,
        disableLinks = {},
        extraButtons
    } = props

    const {
        _id,
        title,
        address
    } = buildingInfo

    return (
        <Card className="building-entry">
            <Card.Body>
                <Card.Title>
                    <b>{title}</b>
                </Card.Title>
                {address && (
                    <Card.Link
                        className={`small text-decoration-none`}
                        href={`${googleAddress(address)}`}
                        target="_blank">
                        {formatAddress(address)}
                    </Card.Link>
                )}

                {details && (
                    <BuildingInfo {...buildingInfo} />
                )}
            </Card.Body>

            <Card.Footer>
                {!disableLinks['view'] && (
                    <Link className="btn btn-primary btn-sm me-1 mb-1" to={`/building/${_id}`}>View</Link>
                )}
                <Link className="btn btn-secondary btn-sm me-1 mb-1" to={`/edit-building/${_id}`}>Edit</Link>
                <Link className="btn btn-danger btn-sm me-1 mb-1" to={`/delete-building/${_id}`}>Delete</Link>
                
                {extraButtons && extraButtons.map((button, index) => (
                    <Button
                        key={index}
                        className="me-1 mb-1"
                        size={'sm'}
                        variant={button.variant ? button.variant : 'secondary'}
                        disabled={button.disabled}
                        onClick={() => button.onClick(buildingInfo)}>
                        {button.label}
                    </Button>
                ))}
            </Card.Footer>
        </Card>
    )
}

export const BuildingInfo = (props: BuildingEntryType) => {
    const { _id, created, title, description, featuredImage, coordinates } = props

    return (
        <div>
            {(coordinates && coordinates.length === 2) ? (
                <div>
                    {`(Lat: ${coordinates[1]}, Lng: ${coordinates[0]})`}
                </div>
            ) : (
                <div className="text-danger">
                    Please Add Coordinates
                </div>
            )}

            <hr />

            <p className="fst-italic text-break">
                {description}
            </p>

            Building ID: {_id}
            {created && (<>
                <br />
                Created: {timeService.getFormattedTime(new Date(created))}
            </>)}

            <br /><br />

            {featuredImage && (
                <>
                    <img className="building-img" src={featuredImage} alt={title} style={{ maxWidth: '300px', width: '100%' }} />
                    <br />
                </>
            )}
        </div>
    )
}